import { formatDurationShort } from '@/services/helpers/throttle';

interface LoginThrottleError {
  remainingSec?: number | string | null;
}

export interface LoginThrottleState {
  throttleRemainingSeconds: number;
  messageType: number;
  errorMsg: string;
  errorMsgLine2: string;
}

export function applyLoginThrottleState(throttleError: LoginThrottleError | null | undefined): LoginThrottleState {
  const remainingSec = Math.max(0, Number.parseInt(String(throttleError && throttleError.remainingSec), 10) || 0);
  const waitTime = formatDurationShort(remainingSec);

  return {
    throttleRemainingSeconds: remainingSec,
    messageType: 1,
    errorMsg: `Please wait ${waitTime} before trying again.`,
    errorMsgLine2: '',
  };
}